import ActionTextIcon from "@/components/icons/ActionTextIcon";
import { AnonymousContentWrapper } from "@/components/wrappers/AnonymousContentWrapper";
import { setErrorsToForm } from "@/utils/formUtils";
import { validations } from "@/utils/validationUtils";
import { Button, Col, Form, Input, Row } from "antd";
import { useTranslation } from "react-i18next";
import { useRequestPasswordReset } from "../../../common/api/queries";
import { AUTH_ROUTE_PATHS } from "../../auth/paths";
import { RequestPasswordReset } from "../types";

export const RequestPasswordResetContainer = () => {
  const { t } = useTranslation();

  const [form] = Form.useForm<RequestPasswordReset>();

  const requestPasswordReset = useRequestPasswordReset();

  const handleFormFinish = (values: RequestPasswordReset) => {
    requestPasswordReset.mutate(values, {
      onError: (error) => setErrorsToForm(form, "user.attrs", error.violations),
    });
  };

  return (
    <AnonymousContentWrapper>
      <h2 className="center-align margin-bottom-large">{t("user.titles.passwordReset")}</h2>

      <Row justify="center">
        <Col style={{ flex: "0 0 400px" }}>
          <Form form={form} layout="vertical" name="requestPasswordResetForm" onFinish={handleFormFinish}>
            <Form.Item
              name="email"
              label={t("user.attrs.email")}
              rules={[validations.notBlank, validations.size(1, 254), validations.email]}
            >
              <Input />
            </Form.Item>

            <Form.Item>
              <Button
                className="margin-top-medium"
                type="primary"
                htmlType="submit"
                block
                loading={requestPasswordReset.isPending}
              >
                {t("user.actions.resetPassword")}
              </Button>
            </Form.Item>

            <div className="center-align margin-top-medium">
              <ActionTextIcon
                color="blue"
                icon="arrow-left"
                text={t("user.actions.backToLogin")}
                path={AUTH_ROUTE_PATHS.login.to}
              />
            </div>
          </Form>
        </Col>
      </Row>
    </AnonymousContentWrapper>
  );
};
